/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_login_for_access_token_api_v1_auth_token_post } from '../models/Body_login_for_access_token_api_v1_auth_token_post';
import type { TokenResponse } from '../models/TokenResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Login For Access Token
     * @returns TokenResponse Successful Response
     * @throws ApiError
     */
    public loginForAccessTokenApiV1AuthTokenPost({
        formData,
    }: {
        formData: Body_login_for_access_token_api_v1_auth_token_post,
    }): CancelablePromise<TokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/token',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Access Token
     * @returns TokenResponse Successful Response
     * @throws ApiError
     */
    public refreshAccessTokenApiV1AuthRefreshPost(): CancelablePromise<TokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/refresh',
        });
    }
}
